/** Идентификатор фильтра списка диалогов по внешней выборке. Колонки у фильтра нет — пользователь его не заполняет. */
export const CONVERSATION_IDS_FILTER_ID = 'conversationIds';

/** Источники внешней выборки диалогов — показатели дашборда качества. */
export const CONVERSATION_SELECTION_SOURCES = [
  'autoInsight',
  'qualityZone',
  'consultantRating',
  'criteriaAverage',
  'lowScore',
  'distribution',
  'trend',
  'alert',
] as const;

/**
 * Источник внешней выборки — показатель дашборда, с которого она пришла. Определяет
 * автоматическое имя сохранённого пресета («Зона качества N. …», «Критерий N. …» и т. д.):
 * состав диалогов о своём происхождении ничего не говорит, а описание выборки — свободный
 * текст, поэтому источник обязан доехать до списка вместе с ней.
 */
export type ConversationSelectionSource = (typeof CONVERSATION_SELECTION_SOURCES)[number];

/**
 * Внешняя выборка диалогов: посчитанный снаружи список разговоров и его описание.
 * Доезжает до страницы списка диалогов состоянием навигации (переход в текущей вкладке)
 * либо через хранилище браузера по ключу в адресе (переход в новой вкладке).
 */
export type ConversationSelection = {
  /** Идентификаторы диалогов выборки */
  conversationIds: number[];
  /** Описание выборки — то, чем показатель подписан на дашборде (текст инсайта, ФИО, название критерия) */
  description: string;
  /** Источник выборки — определяет автоматическое имя сохранённого пресета */
  source: ConversationSelectionSource;
};
